import { Box, FormControlLabel, Switch } from "@mui/material"
import Grid from "@mui/material/Grid"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import Button from "components/Button"
import PaperBox from "components/PaperBox"
import { Formik } from "formik"
import React from "react"
import { contractValidationSchema } from "./ContractValidationSchema"
import { useTranslation } from "react-i18next"

export const ContractForm = ({ onSubmit, editContract, result, feedback }) => {
  const { t } = useTranslation()
  const initialValues = editContract
    ? editContract
    : {
        name: "",
        assignmentNr: "",
        active: false
      }

  const editMode = editContract ? true : false

  const handleSubmit = async (values, { resetForm }) => {
    onSubmit(values)
  }
  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={contractValidationSchema(t)}>
      {({ values, errors, touched, handleChange, handleBlur, isSubmitting, handleSubmit, setFieldValue }) => (
        <form onSubmit={handleSubmit} noValidate>
          <PaperBox>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  autoComplete="off"
                  fullWidth
                  id="name"
                  label={t("global.name", "Name")}
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.name && errors.name ? true : false}
                  helperText={touched.name && errors.name ? errors.name : null}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  autoComplete="off"
                  fullWidth
                  id="assignmentNr"
                  label={t("violation.agreement_number", "Agreement number")}
                  value={values.assignmentNr}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.assignmentNr && errors.assignmentNr ? true : false}
                  helperText={touched.assignmentNr && errors.assignmentNr ? errors.assignmentNr : null}
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </PaperBox>

          <PaperBox>
            <Grid container direction="row" justifyContent="space-between">
              <Grid item>
                <Typography variant="h5">{t("violation.agreement_active", "Agreement active")}</Typography>
                {/* <Typography variant="bodySmall">
                                    Lorem ipsum dolor sit amet, consectetur
                                    adipiscing elit. Ut libero
                                </Typography> */}
              </Grid>
              <Grid item>
                <FormControlLabel
                  control={
                    <Switch
                      onChange={(item) => {
                        const checked = item.target.checked
                        setFieldValue("active", checked)
                      }}
                      checked={values.active}
                    />
                  }
                />
              </Grid>
            </Grid>
          </PaperBox>
          <Grid container direction="row" justifyContent="flex-end">
            <Box my={3}>
              <Button color="primary" type="submit" result={result} feedback={feedback}>
                {editMode
                  ? t("violation.save_agreement", "Save agreement")
                  : t("violation.add_agreement", "Add Agreement")}
              </Button>
            </Box>
          </Grid>
        </form>
      )}
    </Formik>
  )
}
